<template>
    <div class="checkin">
        <div class="row">
            <div class="col-md-7">
                <p class="text-big">Chấm công</p>
                <p class="hour">
                    {{ timenow }}
                </p>
            </div>
            <div class="col-md-5">
                <br>
                
                <qrcode-vue :value="qr" :size="200" :className="'qr'" ></qrcode-vue>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import QrcodeVue from 'qrcode.vue';
import {getQrApi} from '@/api/api';
var thankAudio = new Audio(require('@/assets/thank.mp3'))
export default {
    name: 'CheckIn',
    data() {
        return {
            timenow: '',
            qr:''
        }
    },
    components: {QrcodeVue},
    methods: {
        time() {
        var self = this
        this.timenow = moment().format('HH:mm:ss')

        setInterval(()=>{
            var self = this
            this.timenow = moment().format('HH:mm:ss')
        }, 1000)},

        getQrCode(){
            getQrApi().done((rs)=>{
                this.qr = rs.data.qr; 
            });

        },
    },
    mounted: function() {
        this.time();
        this.getQrCode();
        var channel = this.$pusher.subscribe('dashboard');
        channel.bind('qr-check', ( log ) => {
            this.getQrCode();
            console.log(log);
            if (log.type == 'checkin') {
              this.$awn.success("Chúc " + log.user.fullname + ' có một ngày làm việc hiệu quả');
            } else {
              this.$awn.success("Chào tạm biệt " + log.user.fullname );
            }
            thankAudio.play();
        });
    }
}
</script>
<style scoped>

.qr{

    margin-top: 1em;
}
.checkin{
    min-height: 300px;
}
.text-big{
    margin-top: 1em;
}
.text-big, .hour{
    font-size: 3em;
    font-weight: bold;
    text-transform: uppercase
}
</style>



// WEBPACK FOOTER //
// src/components/CheckIn.vue